import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getBooks } from 'services/connections';
import { Book } from 'types/connection';

export const bookApi = createApi({
    reducerPath: 'bookApi',
    baseQuery: fetchBaseQuery({ baseUrl: '/books' }),
    endpoints: (builder) => ({
        getBooks: builder.query<Book[], void>({
            queryFn: async () => {
                try {
                    const result = await getBooks();
                    return { data: result };
                } catch (error) {
                    return { error: error.message || 'Failed to fetch books' };
                }
            },
        }),
    }),
});

export const useGetBooks = bookApi.endpoints.getBooks.useQuery;
